import React from "react";
import { useNavigate } from "react-router-dom";
import "./DealTable.css";

export default function DealTable({
  deals = [],
  page = 1,
  limit = 50,
  onEdit,
  selectedDeals = [],
  toggleDeal,
  handleSelectAll,
  showBulkMenu,
  setShowBulkMenu,
  setShowAssignModal,
  handleDeleteSelected,
}) {
  const navigate = useNavigate();

  const getStatusClass = (status) => {
    if (status === "Won") {
      return "status-badge status-won";
    }

    if (status === "Lost") {
      return "status-badge status-lost";
    }

    return "status-badge status-active";
  };
const showLastStage =
  deals.length > 0 &&
  deals.every((deal) => deal.status === "Lost");
  const formatDealValue = (rawValue) => {
    const value = Number(rawValue || 0);

    if (value >= 10000000) {
      return `${(value / 10000000).toFixed(
        value % 10000000 === 0 ? 0 : 1
      )} Cr`;
    }

    if (value >= 100000) {
      return `${(value / 100000).toFixed(
        value % 100000 === 0 ? 0 : 1
      )} L`;
    }

    if (value >= 1000) {
      return `${(value / 1000).toFixed(
        value % 1000 === 0 ? 0 : 1
      )} K`;
    }

    return value || 0;
  };

  return (
    <div className="deal-table-wrapper">
      <table className="deal-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Lead Date</th>
            <th>Client Name</th>
            <th>Created On</th>
            <th>Project</th>
            <th>Deal Value</th>
            <th>Stage</th>
            <th>Source</th>
            <th>Campaign Name</th>
            <th>Site Visit</th>
            <th>Meeting Done</th>
            {showLastStage && <th>Last Stage</th>}
            <th>Status</th>
            <th>Assigned To</th>

            <th style={{ width: 70 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <input
                  type="checkbox"
                  checked={
                    deals.length > 0 &&
                    selectedDeals.length === deals.length
                  }
                  onChange={handleSelectAll}
                />

                {selectedDeals.length > 0 && (
                  <div
                    style={{
                      position: "relative",
                    }}
                  >
                    <button
                      type="button"
                      onClick={(event) => {
                        event.stopPropagation();

                        setShowBulkMenu(
                          !showBulkMenu
                        );
                      }}
                      style={{
                        width: 18,
                        height: 18,
                        border: "none",
                        background: "#16A34A",
                        color: "#fff",
                        borderRadius: 4,
                        cursor: "pointer",
                      }}
                    >
                      ▼
                    </button>

                    {showBulkMenu && (
                      <div
                        style={{
                          position: "absolute",
                          top: "110%",
                          right: 0,
                          width: 190,
                          background: "#fff",
                          border:
                            "1px solid #E5E7EB",
                          borderRadius: 8,
                          boxShadow:
                            "0 8px 24px rgba(0,0,0,.12)",
                          zIndex: 999,
                          overflow: "hidden",
                        }}
                      >
                        <div
                          style={{
                            padding: "10px 14px",
                            cursor: "pointer",
                            fontSize: 13,
                            borderBottom:
                              "1px solid #eee",
                          }}
                          onClick={(event) => {
                            event.stopPropagation();

                            setShowAssignModal(
                              true
                            );

                            setShowBulkMenu(
                              false
                            );
                          }}
                        >
                          Assign Deals
                        </div>

                        <div
                          style={{
                            padding: "10px 14px",
                            cursor: "pointer",
                            fontSize: 13,
                            borderBottom:
                              "1px solid #eee",
                          }}
                          onClick={(event) => {
                            event.stopPropagation();

                            if (onEdit) {
                              onEdit(
                                selectedDeals
                              );
                            }

                            setShowBulkMenu(
                              false
                            );
                          }}
                        >
                          Update Selected
                        </div>

                        <div
                          style={{
                            padding: "10px 14px",
                            cursor: "pointer",
                            fontSize: 13,
                            color: "#DC2626",
                          }}
                          onClick={(event) => {
                            event.stopPropagation();
                            handleDeleteSelected();
                          }}
                        >
                          Delete Selected
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </th>
          </tr>
        </thead>

        <tbody>
          {deals.length === 0 ? (
            <tr>
              <td
                colSpan="14"
                className="empty"
              >
                No Deals Found
              </td>
            </tr>
          ) : (
            deals.map((deal, index) => {
              const isSelected =
                selectedDeals.includes(deal.id);

              return (
                <tr
                  key={deal.id}
                  className="deal-row"
                  onClick={() =>
                    toggleDeal(deal.id)
                  }
                  style={{
                    background: isSelected
                      ? "#ECFDF5"
                      : undefined,
                    cursor: "pointer",
                  }}
                >
                  <td>
                    {(page - 1) * limit +
                      index +
                      1}
                  </td>

                  <td>
                    {deal.lead_date
                      ? new Date(
                          deal.lead_date
                        ).toLocaleDateString(
                          "en-GB"
                        )
                      : "-"}
                  </td>

                  <td
  onClick={(event) => {
    event.stopPropagation();

    window.open(`/deals/${deal.id}`, "_blank");
  }}
>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                      }}
                    >
                      <strong
                        style={{
                          color:
                            deal.is_duplicate
                              ? "#DC2626"
                              : "inherit",
                          cursor: "pointer",
                          textDecoration: "none",
                        }}
                        onMouseEnter={(event) => {
                          event.currentTarget.style.textDecoration =
                            "underline";
                        }}
                        onMouseLeave={(event) => {
                          event.currentTarget.style.textDecoration =
                            "none";
                        }}
                      >
                        {deal.deal_name ||
                          deal.client_name ||
                          deal.name ||
                          "-"}
                      </strong>

                      {deal.is_duplicate && (
                        <span
                          style={{
                            background:
                              "#FEE2E2",
                            color: "#DC2626",
                            border:
                              "1px solid #FECACA",
                            borderRadius: 10,
                            padding: "2px 6px",
                            fontSize: 9,
                            fontWeight: 700,
                            whiteSpace:
                              "nowrap",
                          }}
                          title="Same phone number already exists"
                        >
                          Duplicate
                        </span>
                      )}
                    </div>
                  </td>

                  <td>
                    {deal.created_at
                      ? new Date(
                          deal.created_at
                        ).toLocaleDateString(
                          "en-GB"
                        )
                      : "-"}
                  </td>

                  <td>
                    {deal.project_name ||
                      "Not Specified"}
                  </td>

                  <td className="money">
                    {formatDealValue(
                      deal.deal_value
                    )}
                  </td>

                  <td>
                    {deal.stage || "-"}
                  </td>

                  <td>
                    {deal.source || "-"}
                  </td>

                  <td>
                    {deal.campaign_name ||
                      "-"}
                  </td>

                  <td>
                    {deal.site_visit_date
                      ? new Date(
                          deal.site_visit_date
                        ).toLocaleDateString(
                          "en-GB"
                        )
                      : "-"}
                  </td>

                  <td>
                    {deal.meeting_date
                      ? new Date(
                          deal.meeting_date
                        ).toLocaleDateString(
                          "en-GB"
                        )
                      : "-"}
                  </td>
{showLastStage && (
  <td>{deal.last_stage || "-"}</td>
)}
                  <td>
                    <span
                      className={getStatusClass(
                        deal.status
                      )}
                    >
                      {deal.status || "Active"}
                    </span>
                  </td>

                  <td>
                    {deal.assigned_name ||
                      "Unassigned"}
                  </td>

                  <td
                    onClick={(event) =>
                      event.stopPropagation()
                    }
                  >
                    <input
                      type="checkbox"
                      checked={isSelected}
                      onChange={() =>
                        toggleDeal(deal.id)
                      }
                    />
                  </td>
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
}